import type { FeatureEvents, ScreenEvent, TrackEvent, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject, TrackAction, TrackActionSubject } from '../new-analytics-types';

const unifiedTeamsListScreen = 'unifiedTeamsListScreen';

type ScreenKeys = 'unifiedTeamsListScreen' | 'unifiedTeamsListCreateTeamModal';
type UiKeys = 'createTeamButtonClicked';
type TrackKeys = 'teamCreated';

const unifiedTeamsListCreateTeamModal = 'teamCreateDialog';

export const unifiedTeamsListEvents: FeatureEvents<ScreenKeys, UiKeys, TrackKeys, never> = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/PTC/pages/5852480663/Analytics+Spec+Teams+directory',
  screen: {
    unifiedTeamsListScreen: ({
      totalTeamsCount,
      managedTeamsCount,
    }: {
      totalTeamsCount: number;
      managedTeamsCount: number;
    }): ScreenEvent => ({
      data: {
        name: unifiedTeamsListScreen,
        attributes: {
          totalTeamsCount,
          managedTeamsCount,
        },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/89383',
    }),
    unifiedTeamsListCreateTeamModal: (): ScreenEvent => ({
      data: {
        name: unifiedTeamsListCreateTeamModal,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/89382',
    }),
  },
  ui: {
    createTeamButtonClicked: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'createTeamButton',
        source: unifiedTeamsListScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/72406',
    }),
  },
  track: {
    teamCreated: (attributes: { source: string; membersAdded: number; createdTeamId: string }): TrackEvent => ({
      data: {
        action: TrackAction.Succeeded,
        actionSubject: TrackActionSubject.TeamCreateDialog,
        source: unifiedTeamsListScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/89384',
    }),
  },
  operational: {},
};
